import Vue from 'vue';
import App from './components/App';

// BootstrapVue add
import BootstrapVue from 'bootstrap-vue';
// Router & Store add
import router from './router';
import store from './store';
// Multi Language Add
import en from './locales/en.json';
import es from './locales/es.json';
import VueI18n from 'vue-i18n';
import { defaultLocale, localeOptions} from './constants/config';
// Notification Component Add
import Notifications from './components/Common/Notification';
// Breadcrumb Component Add
import Breadcrumb from './components/Common/Breadcrumb';
// RefreshButton Component Add
import RefreshButton from './components/Common/RefreshButton';
// Colxx Component Add
import Colxx from './components/Common/Colxx';
// Perfect Scrollbar Add
import vuePerfectScrollbar from 'vue-perfect-scrollbar';
import contentmenu from 'v-contextmenu';
import VueLineClamp from 'vue-line-clamp';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import VueScrollTo from 'vue-scrollto';

import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import VueHtmlToPaper from 'vue-html-to-paper';

// import Vuelidate from 'vuelidate'
// Vue.use(Vuelidate);

Vue.use(BootstrapVue);
Vue.use(VueI18n);

const messages = { en: en, es: es };
const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    messages,
});

import {mask} from 'vue-the-mask';

Vue.directive( 'mask' , mask);

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

Vue.use(Notifications);
Vue.component('piaf-breadcrumb', Breadcrumb);
Vue.component('v-select', VueSelect);
Vue.component('b-refresh-button', RefreshButton);
Vue.component('b-colxx', Colxx);
Vue.component('vue-perfect-scrollbar', vuePerfectScrollbar);
Vue.use(require('vue-shortkey'));
Vue.use(contentmenu);
Vue.use(VueLineClamp, {
    importCss: true
});
Vue.use(VCalendar, {
    firstDayOfWeek: 2,
    formats: {
        title: 'MMM YY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['MM-DD-YYYY', 'YYYY/MM/DD', 'L'],
        dayPopover: 'L'
    },
    datePickerShowDayPopover: false,
    popoverExpanded: true,
    popoverDirection: 'bottom'
});
Vue.use(VueScrollTo);

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        '/css/app.css',
    ]
}

Vue.use(VueHtmlToPaper, options);


Vue.config.productionTip = false;

require('./bootstrap');

const app = new Vue({
    el: '#app',
    i18n,
    router,
    store,
    render: h => h(App),
    data: {
        loading: true,
    },
    mounted() {
      return this.loading = false;
    },
});
export default app;
